import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const queryClient = new QueryClient();

type UniversalLayoutContainerProps = {
  children: React.ReactNode;
};

/**
 * A container that wraps its children in a react-query QueryClientProvider.
 * Any calls to useUniversalNavContext or UniversalNavProvider not wrapped in UniversalLayoutQueryContainer must be wrapped by this component somewhere up the hierarchy.
 */
export const UniversalLayoutQueryContainer = ({
  children,
}: UniversalLayoutContainerProps) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
